<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <b-overlay :show="isLoading" class="rounded" variant="transparent">
        <template #overlay>
          <b-img
            width="100"
            :src="require('@/assets/img/brand/loader.gif')"
            alt=""
          />
        </template>
        <div class="card bg-secondary shadow border-0 rounded">
          <div class="card-header bg-transparent pb-2">
            <div class="text-muted text-center mt-2 mb-1">
              <h3>{{ $t("recovery") }}</h3>
              <img src="favicon.png" class="icon-app" alt="" />
            </div>
          </div>
          <div class="card-body px-lg-5 py-lg-4">
            <form role="form">
              <base-input
                class="input-group-alternative border"
                :placeholder="$t('email')"
                type="email"
                addon-left-icon="ni ni-email-83"
                data-vv-validate-on="blur"
                v-validate="'required|email'"
                :data-vv-as="$t('email')"
                name="email"
                ref="email"
                v-model="model.email"
              >
              </base-input>
              <span class="text-danger text-sm" v-show="errors.has('email')"
                ><small>{{ errors.first("email") }}</small></span
              >
              <base-input
                class="input-group-alternative border"
                :placeholder="$t('password')"
                type="password"
                addon-left-icon="ni ni-lock-circle-open"
                data-vv-validate-on="blur"
                v-validate="'required|min:8|max:20'"
                :data-vv-as="$t('password')"
                name="password"
                ref="password"
                v-model="model.password"
              >
              </base-input>
              <span class="text-danger text-sm" v-show="errors.has('password')"
                ><small>{{ errors.first("password") }}</small></span
              >

              <base-input
                class="input-group-alternative border"
                :placeholder="$t('password_confirmation')"
                type="password"
                addon-left-icon="ni ni-lock-circle-open"
                v-model="model.password_confirmation"
                data-vv-validate-on="blur"
                v-validate="'required|min:8|max:20|confirmed:password'"
                name="password_confirmation"
                :data-vv-as="$t('password_confirmation')"
              >
              </base-input>
              <span
                class="text-danger text-sm"
                v-show="errors.has('password_confirmation')"
                ><small>{{
                  errors.first("password_confirmation")
                }}</small></span
              >

              <div class="text-center">
                <base-button type="primary" class="my-4" @click="restore">{{
                  $t("restore_password")
                }}</base-button>
              </div>
            </form>
          </div>
        </div>
      </b-overlay>
      <div class="row mt-3">
        <div class="col-12 text-right">
          <router-link to="/login" class="text-light">
            <small> {{ $t("into_login") }}</small>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "register",
  data() {
    return {
      model: {
        token: this.$route.params.token,
        password: "",
        password_confirmation: "",
        email: "",
      },
    };
  },
  methods: {
    ...mapActions({
      restorePassword: "restorePassword",
    }),
    async restore() {
      const validation = await this.$validator.validateAll();
      if (validation) {
        const res = await this.restorePassword(this.model);
        if (res.status === 200 || res.status === 201) {
          this.$toast.success(res.data.data.message, {
            position: "top-right",
          });
          this.$router.push({ name: "login" });
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      isLoading: "isLoading",
    }),
  },
};
</script>
<style scope>
.icon-app {
  max-height: 7rem;
}
</style>
